module.exports = __webpack_public_path__ + "img/MC1.98f06cf5.webp";